{
  "box.1.label": "Sender (name, address, country)",
  "box.2.label": "Consignee (name, address, country)",
  "box.3.label": "Place of delivery of the goods (place, country)",
  "box.4.label": "Place and date of taking over the goods (place, country, date)",
  "box.5.label": "Documents attached",
  "box.6.label": "Marks and numbers",
  "box.7.label": "Number of packages",
  "box.8.label": "Method of packing",
  "box.9.label": "Nature of the goods",
  "box.10.label": "Statistical number",
  "box.11.label": "Gross weight in kg",
  "box.12.label": "Volume in m3",
  "box.13.label": "Sender's instructions",
  "box.14.label": "Instructions as to payment for carriage",
  "box.15.label": "Cash on delivery",
  "box.16.label": "Carrier (name, address, country)",
  "box.17.label": "Successive carriers (name, address, country)",
  "box.18.label": "Carrier's reservations and observations",
  "box.19.label": "Special agreements",
  "box.20.label": "To be paid by",
  "box.21.label": "Established in, on",
  "box.22.label": "Signature and stamp of the sender",
  "box.23.label": "Signature and stamp of the carrier",
  "box.24.label": "Goods received (place, date, signature and stamp of the consignee)",
  "box.18.continued": "Not everything fits in this box. The full list of {total, plural, one {# reservation} other {# reservations}} is in the annex on page {page}.",
  "annex.box18": "Annex box 18 — carrier's reservations and observations",
  "document.title": "International consignment note",
  "document.convention_note": "This carriage is subject, notwithstanding any clause to the contrary, to the CMR Convention.",
  "document.ecmr_number": "Consignment note number",
  "document.reference": "Reference",
  "document.version": "Version {version}",
  "document.continuation": "Continuation",
  "document.page_of": "Page {page} of {pages}",
  "document.inspection_code": "Inspection code",
  "document.efti_certification": "eFTI platform: not certified (test)",
  "label.vat_number": "VAT number",
  "label.vehicle": "Vehicle",
  "label.trailer": "Trailer",
  "label.driver": "Driver",
  "label.window": "Time window",
  "label.dangerous_goods": "Dangerous goods (ADR)",
  "label.adr_class": "Class",
  "label.adr_packing_group": "Packing group",
  "label.adr_tunnel_code": "Tunnel code",
  "label.adr_limited_quantity": "Limited quantity",
  "label.adr_environmentally_hazardous": "Environmentally hazardous",
  "label.carriage_charges": "Carriage charges",
  "label.total": "Total",
  "value.payer.consignor": "Sender",
  "value.payer.consignee": "Consignee",
  "value.payer.principal": "Principal",
  "value.carriage_paid": "Carriage paid",
  "value.carriage_forward": "Carriage forward",
  "value.package.pallet": "Pallet",
  "value.package.box": "Box",
  "value.package.carton": "Carton",
  "value.package.crate": "Crate",
  "value.package.bag": "Bag",
  "value.package.drum": "Drum",
  "value.package.roll": "Roll",
  "value.package.bundle": "Bundle",
  "value.package.container": "Container",
  "value.package.loose": "Loose",
  "value.package.other": "Other",
  "signature.signed_electronically": "Electronically signed via Cargofollow",
  "signature.pending": "Not signed yet",
  "signature.method.drawn": "Drawn on screen",
  "signature.method.click_otp": "Confirmed with a one-time code",
  "signature.method.api": "Signed through the API",
  "signature.method.photo_of_paper": "Photo of a paper signature",
  "signature.trust.platform_auth": "Platform authentication",
  "signature.trust.ades": "Advanced signature (AdES)",
  "signature.trust.qes": "Qualified signature (QES)",
  "signature.seal": "Seal of a legal person",
  "label.signed_at": "Signed at",
  "label.method": "Method",
  "label.trust_level": "Trust level",
  "label.document_hash": "Document hash",
  "label.location": "Location",
  "label.accuracy": "Accuracy",
  "pod.title": "Proof of delivery",
  "pod.intro": "Proof of delivery for the consignment note above.",
  "pod.delivered_at": "Delivered at",
  "pod.consignee_signature": "Signature of the consignee",
  "pod.colli": "Package check",
  "pod.colli_expected": "Packages on the consignment note",
  "pod.remarks": "Reservations and remarks",
  "pod.no_remarks": "Delivered without reservations.",
  "pod.remarks_on_form": "Not everything fits here. The full list is in box 18 of the consignment note on page 1.",
  "pod.photos": "Photos",
  "pod.photos_omitted": "{count} photo(s) not shown to keep the document small.",
  "pod.remark.phase.pickup": "At taking over",
  "pod.remark.phase.delivery": "At delivery",
  "pod.remark.type.damage": "Damage",
  "pod.remark.type.shortage": "Shortage",
  "pod.remark.type.delay": "Delay",
  "pod.remark.type.other": "Other"
}
